<template>
  <Grid>
    <Col12 v-if="editMealPlan">
      <Button
        :label="translate(`${LOCALE_PREFIX}.form.domains.domainsButton`)"
        outlined
        @click="openDialog"
      />
    </Col12>

    <Col12>
      <span class="text-sm font-medium mr-2">{{
        translate(`${LOCALE_PREFIX}.form.domains.mealplanAccess`)
      }}</span>
      <span>{{
        translate(`${LOCALE_PREFIX}.form.domains.mealPlanAccessValue`, {
          number: numberDomains,
        })
      }}</span>
    </Col12>
  </Grid>

  <DomainsDialog
    v-if="dialogVisible"
    v-model:visible="dialogVisible"
    :domains="value"
    @add-domains="updateValue"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { useField } from 'vee-validate';
import { computed, inject, ref } from 'vue';
import DomainsDialog from './domains-dialog/DomainsDialog.vue';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../enums';
import { useFinancialConfigStore } from '../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');

// Set valid domains field
const { value } = useField<string[]>(`${formNamespace}valid_email_domains`);

// Ref for dialog visibility
const dialogVisible = ref<boolean>(false);

// Computed property for valid domains
const numberDomains = computed<number>(() => value.value?.length);

// Method to open dialog
const openDialog = (): void => {
  dialogVisible.value = true;
};

// Update value on dialog close
const updateValue = (domains: string[]): void => {
  value.value = domains;
};
</script>
